import { z } from 'zod'

export const addFamilySchema = z.object({
  family: z.string({ required_error: "חובה להכניס שם משפחה" }).nonempty("חובה להכניס שם משפחה"),
  name_a: z.string({ required_error: "חובה להכניס שם הורה 1" }).nonempty("חובה להכניס שם הורה 1"),
  name_b: z.string({ required_error: "חובה להכניס שם הורה 2" }).nonempty("חובה להכניס שם הורה 2"),
  residence_location: z.string({ required_error: "חובה להכניס אזור מגורים" }).nonempty("חובה להכניס אזור מגורים"),
  phone: z.string({ required_error: "חובה להכניס מספר טלפון" }).nonempty("חובה להכניס מספר טלפון")
    .regex(/^0\d{9}$/, "מספר טלפון חייב להתחיל ב־0 ולהכיל 10 ספרות"),
  email: z.string({ required_error: "חובה להכניס כתובת אימייל" })
    .nonempty("חובה להכניס כתובת מייל")
    .email("כתובת מייל לא תקנית"),
  num_of_children: z.string({ required_error: "חובה להכניס מספר ילדים" }).nonempty("חובה להכניס מספר ילדים"),
  status: z.enum(['ok', 'needs_attention', 'no_meeting_month'], {
    required_error: "חובה לבחור סטטוס",
    invalid_type_error: "סטטוס לא תקין"
  })
});

export const updateFamilySchema = z.object({
  family: z.string({ required_error: "חובה להכניס שם משפחה" }).nonempty("חובה להכניס שם משפחה"),
  phone: z.string({ required_error: "חובה להכניס מספר טלפון" }).nonempty("חובה להכניס מספר טלפון")
    .regex(/^0\d{9}$/, "מספר טלפון חייב להתחיל ב־0 ולהכיל 10 ספרות"),
  email: z.string({ required_error: "חובה להכניס כתובת אימייל" })
    .nonempty("חובה להכניס כתובת מייל")
    .email("כתובת מייל לא תקנית"),
  num_of_children: z.string({ required_error: "חובה להכניס מספר ילדים" }).nonempty("חובה להכניס מספר ילדים"),
  status: z.enum(['ok', 'needs_attention', 'no_meeting_month'], {
    required_error: "חובה לבחור סטטוס",
    invalid_type_error: "סטטוס לא תקין"
  }),
   mentorName: z.string({ required_error: "חובה להכניס שם מלווה" }).nonempty("חובה להכניס שם מלווה"),
});

export type updateFamilyInput = z.infer<typeof updateFamilySchema>;

export type addFamilyInput = z.infer<typeof addFamilySchema>;





